class Complement {
    constructor(el, options = {}){
        this.options = Object.assign(
            {},
            {     
                state: true,
                lang: "fr", 
                country : "france", 
                countryCode : "FR",
                email: "", 
                complement: "",
                init: true
            }, 
            options 
        );  

        this.contentComplement = el;
        this.buttonSend = this.contentComplement.querySelector("#btn-acces");
        this.countrySelect = this.contentComplement.querySelector("#country");
        this.email = this.contentComplement.querySelector("#email");
        this.initComplementCookie();
        this.contentContact = document.querySelector(".footer .content-contact");
 
        this.countrySelect.addEventListener("change", (e) => {
            this.options.countryCode = e.target.value;
            this.options.country = this.countrySelect.options[e.target.selectedIndex].innerText;
        });

        this.buttonSend.addEventListener("click", () => {  
            this.options.email = this.email.value;
            this.track();
        });

        let indexBullet = 0;

        this.contentComplement.querySelector(".fiches-coaching").addEventListener("scroll", (e) => { 
            let wFiche = this.contentComplement.querySelectorAll(".fiches-coaching .fiche")[0].offsetWidth;
            let index = Math.floor(e.target.scrollLeft / (wFiche - 60)); 
            if(index != indexBullet && index < this.contentComplement.querySelectorAll(".fiches-coaching .fiche").length){ 
                indexBullet = index;
                this.contentComplement.querySelector(".content-bullets .content-bullet.active").classList.remove("active");
                this.contentComplement.querySelectorAll(".content-bullets .content-bullet")[index].classList.add("active");
            }
        });

        const questions = document.querySelectorAll(".content-faq .q h3");

        questions.forEach(i => {
            i.addEventListener("click", () => {
                var parent = i.closest(".q-r");
                parent.classList.toggle("open");  
            });
        }); 

        document.querySelector(".send-form").addEventListener("click", (e) => { 
            e.target.classList.add("loading");
            this.sendForm();
        });

        document.querySelector(".contact-open").addEventListener("click", () => {
            if(this.contentContact.classList.contains("hide")){
                this.contentContact.classList.remove("hide");
                let top = this.contentContact.offsetTop;
                window.scroll(0, top);
            }
        });

        document.querySelectorAll(".prescription .control").forEach(btn => {
            btn.addEventListener("click", (e) => { 
                e.target.closest(".c").classList.toggle("open");
            });
        }); 

        document.querySelectorAll(".exigence .control").forEach(btn => {
            btn.addEventListener("click", (e) => { 
                e.target.closest(".c").classList.toggle("open");
            });
        }); 

        document.querySelectorAll(".exigence ul li h4").forEach(item => {
            item.addEventListener("click", (e) => { 
                item.closest("li").classList.toggle("open");
            });
        }); 

        document.querySelectorAll(".content-store-locator .control").forEach(btn => {
            btn.addEventListener("click", (e) => { 
                e.target.closest(".content-store-locator").classList.toggle("open");
            });
        }); 

        document.querySelectorAll(".audio").forEach(audio => {
            audio.addEventListener("click", (e)=>{ 
                if(audio.classList.contains("played")){
                    document.querySelector("#player").pause();
                    audio.classList.remove("played");
                }else{
                    document.querySelectorAll(".audio").forEach(a => {
                        if(a.classList.contains("played")){
                            a.classList.remove("played");
                        }
                    });
                    let srcAudio = audio.getAttribute("data-src");
                    audio.classList.add("played");
                    document.querySelector("#player").setAttribute("src", srcAudio);
                    document.querySelector("#player").play(); 
                }
            });
        });

        document.querySelector("#player").addEventListener("play", ()=>{
            if(!document.querySelector(".content-player").classList.contains("played")){
                document.querySelector(".content-player").classList.add("played");
            } 
        });

        document.querySelector("#player").addEventListener("pause", ()=>{
            if(document.querySelector(".content-player").classList.contains("played")){
                document.querySelector(".content-player").classList.remove("played");
            } 
            document.querySelectorAll(".audio").forEach(audio => {
                if(audio.classList.contains("played")){ 
                    audio.classList.remove("played");
                }
            });
        });

        document.querySelectorAll(".fiche").forEach(fiche => {
            fiche.addEventListener("click", () => {
                let openSrc = fiche.getAttribute("data-open");
                document.querySelector(`.content-fiche-file[data-open='${openSrc}']`).classList.add("open");
                document.querySelector(`body`).classList.add("fiche-open");
            });
        });

        document.querySelectorAll(".content-fiche-file .close").forEach(close => {
            close.addEventListener("click", () => { 
                close.closest(`.content-fiche-file`).classList.remove("open");
                document.querySelector(`body`).classList.remove("fiche-open");
            });
        });
 
    } 
 
    deleteCookie(name){ 
        document.cookie = name + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    }  
    
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    
    setCookie(name,value,days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }  

    initComplementCookie(){  
        setTimeout(()=>{
            if(this.getCookie(`complement_${this.options.complement}`) == null){
                let complement_cookie = { 
                    "save" : false,
                    "date" : "",
                    "month" : 1
                };
                let c = JSON.stringify(complement_cookie);
                this.setCookie(`complement_${this.options.complement}`, c, 365);  
                this.goToStep(1);
            }else{
                let c = JSON.parse(this.getCookie(`complement_${this.options.complement}`));
                if(c.save){
                    this.options.init = false; 
                    this.goToStep(2);
                }else{
                    this.goToStep(1);
                }
            }
            document.querySelector("body").classList.add("loaded");
        }, 2000);
    }   

    validationEmail(email){
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (email.match(validRegex)) {
            return true;
        }else{
            return false;
        }
    } 

    goToStep(step){
        if(document.querySelector(`.step.off`) != null){
            document.querySelector(`.step.off`).classList.remove("off");
        } 
        if(document.querySelector(`.step.loaded`) != null){
            document.querySelector(`.step.loaded`).classList.remove("loaded");
        }  
        document.querySelector(`.step[data-step="${step}"]`).classList.add("loaded"); 
        //this.checkMonthRest();
    }

    checkMonthRest(){
        const date = new Date(); 
        let c = JSON.parse(this.getCookie(`complement_${this.options.complement}`));  
        let d = new Date(c.date);
        let monthCount = 1;
        var month2 =  new Date(d.setMonth(d.getMonth() + 1)).getTime();
        var month3 =  new Date(d.setMonth(d.getMonth() + 1)).getTime();  
        var now = new Date().getTime();
        var m2 = month2 - now;  
        var m3 = month3 - now;  
        let daysM = [];
        daysM[2] = Math.floor(m2 / (1000 * 60 * 60 * 24));
        daysM[3] = Math.floor(m3 / (1000 * 60 * 60 * 24)); 
        if(daysM[2] < 0){
            monthCount++;
        }
        if(daysM[3] < 0){
            monthCount++;
        }
        if(c!=monthCount){ 
            c.month = monthCount;
            let cF = JSON.stringify(c);
            this.setCookie(`complement_${this.options.complement}`, cF, 365);  
        } 
        document.querySelectorAll(".content-fiche-coaching .fiche").forEach((f, i) => {
            if(i != 0){ 
                let monthRef = parseInt(f.getAttribute("data-month")); 
                if(monthRef <= monthCount){
                    f.classList.add("active");
                }else{
                    f.querySelector("h3 span").innerHTML = daysM[i+1];
                }
            } 
        });
    }
 
    saveComplementCookie(){
        if(this.getCookie(`complement_${this.options.complement}`) != null){
            let c = JSON.parse(this.getCookie(`complement_${this.options.complement}`));  
            const date = new Date(); 
            let day = this.formatZero(date.getDate());
            let month = this.formatZero(date.getMonth() + 1);
            let year = date.getFullYear();  
            c.date = `${year}-${month}-${day}`;
            c.save = true;
            let cF = JSON.stringify(c);
            this.setCookie(`complement_${this.options.complement}`, cF, 365); 
            this.goToStep(2);
        }
    }

    async track(){    

        this.buttonSend.querySelector(".content-loader").classList.add("show");

        const options = {
            method: 'POST',
            headers: {
                Accept: 'text/html', 
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                data: `{
                    "token": "${app.klaviyo.token}", 
                    "event": "complement", 
                    "customer_properties": {
                        "$email": "${this.options.email}",
                        "$consent" : "web"
                    },
                    "properties": { 
                        "complement_lang": "${this.options.lang}", 
                        "complement_country" : "${this.options.country}", 
                        "complement_countryCode" : "${this.options.countryCode}", 
                        "complement": "${this.options.complement}"
                    }
                }`
            })
        };

        const trackK = await fetch('https://a.klaviyo.com/api/track', options); 

        if(trackK.ok){
            console.log("tracking klaviyo"); 
        }
 
        await this.checkKlaviyo(this.options.email); 
         
    } 

    formatZero(number){
        number = parseInt(number);
        if (number < 10) {
            number = "0" + number;
        }
        return number;
    }


    async checkKlaviyo(dataEmail){  
        let options = {
            method: "POST",
            body: JSON.stringify({email: dataEmail, listId: app.klaviyo.list_id})
        };
        const call = await fetch(`${app.aws.url}/klaviyo/checklist`, options);  
        const rep = await call.json();  

        if(rep.rep.data.length == 0){ 
            await this.subKlaviyo(dataEmail); 
        }else{
          let sub = false;
          rep.rep.data.forEach(d => {
            if(d.id == app.klaviyo.list_id){
              sub = true;
            }
          });
          if(!sub){
            await this.subKlaviyo(dataEmail);
          }else{
            console.log("already save"); 
            this.saveComplementCookie();
          }
        } 
    }

    async subKlaviyo(dataEmail){  
        let options = {
            method: "POST",
            body: JSON.stringify({email: dataEmail, listId: app.klaviyo.list_id, source: `complement_${this.options.complement}`})
        };
        const call = await fetch(`${app.aws.url}/klaviyo/subscribe`, options);  
        const rep = await call.json();  
        if(typeof rep.statut != "undefined" && rep.statut == "save"){
            console.log("sub success"); 
            this.saveComplementCookie();
        }   
    }



    validationEmail(email){
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (email.match(validRegex)) {
            return true;
        }else{
            return false;
        }
    }

    validationEmpty(value){
        if(value.length > 1){
            return true;
        }else{
            return false; 
        }
    }

    resetErrors(){
        if(this.contentContact.querySelector(".errors").classList.contains("on")){
            this.contentContact.querySelector(".errors").classList.remove("on");
            this.contentContact.querySelector(".errors .count").innerHTML = "";
            this.contentContact.querySelector(".errors .description").innerHTML = "";
        }
        this.contentContact.querySelectorAll(".required.error").forEach(inp => {
            inp.classList.remove("error");
        });
    }

    resetForm(){
        resetErrors();
    }

    nbErrors(nb){
        if(nb > 1){
            return nb + " erreurs";
        }else{
            return nb + " erreur";
        } 
    }

    async trackContact(email, obj, callBack){  
        var objToString = ""; 
        Object.entries(obj).forEach((field, index) => { 
            objToString += `"${field[0]}" : "${field[1]}"`;  
            if(index < Object.entries(obj).length - 1){
                objToString += "," 
            }
        }); 

        const options = {
            method: 'POST',
            headers: {
                Accept: 'text/html', 
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                data: `{
                    "token": "${app.klaviyo.token}",  
                    "event": "contact", 
                    "customer_properties": {
                        "$email": "${email}"
                    },
                    "properties": {
                        ${objToString}
                    }
                }`
            })
        };

        const trackK = await fetch('https://a.klaviyo.com/api/track', options); 

        if(trackK.ok){
            console.log("tracking klaviyo"); 
            this.contentComplement.querySelector(".footer .content-cta").classList.add("hide");
            this.contentContact.classList.add("send");
            this.contentContact.querySelector(".send-form").classList.remove("loading");
            let top = this.contentContact.offsetTop;
            window.scroll(0, top);
           
        }  

        if(typeof callBack == "function"){
            callBack();
        }
        
    } 

    sendForm(){ 
        let error = false;
        let countErrors = 0;
        let listErrors = [];

        this.resetErrors();

        let email = this.contentContact.querySelector("#ContactFormEmail").value; 
        let name = this.contentContact.querySelector("#ContactFormName").value;
        let forname = this.contentContact.querySelector("#ContactFormForName").value;
        let society = this.contentContact.querySelector("#ContactFormSociety").value;
        let message = this.contentContact.querySelector("#ContactFormMessage").value;
        let number = this.contentContact.querySelector("#ContactFormPhone").value; 

        if(!this.validationEmail(email)){
            this.contentContact.querySelector("#ContactFormEmail").classList.add("error");
            error = true;
            countErrors++;
            listErrors.push("Champs email invalide.");
        }else{
            if(this.contentContact.querySelector("#ContactFormEmail").classList.contains("error")){
                this.contentContact.querySelector("#ContactFormEmail").classList.remove("error");
            }
        }

        if(!this.validationEmpty(name)){
            this.contentContact.querySelector("#ContactFormName").classList.add("error");
            error = true;
            countErrors++;
            listErrors.push("Champs nom invalide.");
        }else{
            if(this.contentContact.querySelector("#ContactFormName").classList.contains("error")){
                this.contentContact.querySelector("#ContactFormName").classList.remove("error");
            }
        }

        if(!this.validationEmpty(forname)){
            this.contentContact.querySelector("#ContactFormForName").classList.add("error");
            error = true;
            countErrors++;
            listErrors.push("Champs prénom invalide.");
        }else{
            if(this.contentContact.querySelector("#ContactFormForName").classList.contains("error")){
                this.contentContact.querySelector("#ContactFormForName").classList.remove("error");
            }
        }

        if(!this.validationEmpty(message)){
            this.contentContact.querySelector("#ContactFormMessage").classList.add("error");
            error = true;
            countErrors++;
            listErrors.push("Champs message invalide.");
        }else{
            if(this.contentContact.querySelector("#ContactFormMessage").classList.contains("error")){
                this.contentContact.querySelector("#ContactFormMessage").classList.remove("error");
            }
        }

        if(!error){
            let obj = {
                "mode" : "normal",
                "partner" : 0,
                "subject" : "Complement",
                "name" : forname + " " + name,
                "society" : society, 
                "message" : message.replace(/(?:\r\n|\r|\n)/g, " "), 
                "number" : number  
            };
            this.trackContact(email, obj);
        }else{
            this.contentContact.querySelector(".errors").classList.add("on");
            this.contentContact.querySelector(".errors .count").innerHTML = this.nbErrors(countErrors);
            let listErrorsHtml = document.createElement("ul");
            listErrors.forEach(er => { 
                let li = document.createElement("li");
                li.innerText = er;
                listErrorsHtml.append(li);
            });
            this.contentContact.querySelector(".errors .description").append(listErrorsHtml);
            this.contentContact.querySelector(".send-form").classList.remove("loading");
        }
    }

}